/* -----------------Types--------------- */
import type { Plan } from "@memorang/types/src/bundle";

/* -----------------Child components--------------- */
import MarkdownRenderer from "@memorang/ui/src/components/MarkdownRenderer";
import pluralize from "pluralize";
import { getSubscriptionIntervalText } from "../../helpers/purchase";

type RecommendedPlanTextProps = {
	recommendedPlan: Plan;
	selectedDate?: string;
	isSubscriptionEnabled?: boolean;
};
const RecommendedPlanText = ({
	recommendedPlan,
	selectedDate,
	isSubscriptionEnabled,
}: RecommendedPlanTextProps) => {
	const subscriptionText = getSubscriptionIntervalText(
		recommendedPlan.interval,
		recommendedPlan.duration,
		false,
	);

	const text = isSubscriptionEnabled
		? `We recommend the **${subscriptionText} subscription** for continuous access and preparation for your exam on **${selectedDate}**`
		: `We recommend the "**${recommendedPlan.duration} ${pluralize(recommendedPlan.interval, recommendedPlan.duration)}**" plan to best prepare for your exam on **${selectedDate}**`;
	return <MarkdownRenderer text={text} textAlign="center" />;
};
export default RecommendedPlanText;
export type { RecommendedPlanTextProps };
